import React from 'react'
import PropTypes from 'prop-types'
import {Text, Tooltip} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const FeeCell = ({getValue}) => {
  const {t} = useTranslation('pointsOnPayments')
  const price = getValue()

  if (!price) {
    return (
      <Text
        textDecoration="underline dotted"
        textUnderlineOffset="3px"
        color="mld.neutral.500"
      >
        <Tooltip label={t('pointsOnPayments:bill.table.columns.body.feeTooltip')} placement="bottom" hasArrow>
          <Text as="span" cursor="default">
            {t('pointsOnPayments:bill.table.columns.body.notAvailable')}
          </Text>
        </Tooltip>
      </Text>
    )
  }

  return (
    <Text textDecoration="underline dotted" textUnderlineOffset="3px">
      <Tooltip label={t('pointsOnPayments:bill.table.columns.body.feeTooltip')} placement="bottom" hasArrow>
        <Text as="span" cursor="default">
          {price.toFormat()}
        </Text>
      </Tooltip>
    </Text>
  )
}

FeeCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default FeeCell
